import React from 'react';
import Logo from '../Logo';
import './ScreenHeader.css';

interface ScreenHeaderProps {
  title?: string;
  className?: string;
}

const ScreenHeader: React.FC<ScreenHeaderProps> = ({
  title = 'Tracker Leak Detection',
  className = '',
}) => {
  return (
    <div className={`screen-header ${className}`} data-testid="screen-header">
      <div className="logo-section">
        <Logo />
      </div>
      <div className="title-section">
        <h1 data-testid="title">{title}</h1>
      </div>
    </div>
  );
};

export default ScreenHeader;
